import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import {inject, makeStateKey, TransferState} from '@angular/core';
import {IS_BROWSER} from '@shared/constants/is-browser.token';
import {ErrorsHelper} from '@shared/helper/errors.helper';
import {Observable, tap, throwError} from 'rxjs';

export const SSR_TRANSFER = new HttpContextToken<boolean>(() => false);

interface ITransferredResult {
  status: number;
  body: unknown;
}

const AUTHORIZATION_HEADER = 'Authorization';

export function ssrTransferInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (!req.context.get(SSR_TRANSFER) || req.headers.has(AUTHORIZATION_HEADER)) {
    return next(req);
  }

  const transferState = inject(TransferState);
  const isBrowser = inject(IS_BROWSER);
  const key = makeStateKey<ITransferredResult>(`ssr-${req.urlWithParams}`);

  if (!isBrowser) {
    return next(req).pipe(
      tap({
        error: (error: unknown) => {
          if (
            error instanceof HttpErrorResponse &&
            ErrorsHelper.isNotFoundResponse(error)
          ) {
            transferState.set(key, {status: error.status, body: error.error});
          }
        },
      })
    );
  }

  const transferred = transferState.get(key, null);

  if (!transferred) {
    return next(req);
  }

  transferState.remove(key);

  return throwError(
    () =>
      new HttpErrorResponse({
        status: transferred.status,
        url: req.url,
        error: transferred.body,
      })
  );
}
